<template>
  <AdvancedMarker :options="markerOptions"/>
</template>

<script setup>
import {AdvancedMarker} from 'vue3-google-map';
import {onUnmounted, ref, defineEmits} from 'vue';

const blueDot = document.createElement('img');
blueDot.src = 'https://www.gla.ac.uk/t4/uofglife/app_assets/current_location.png';
blueDot.style.transform = 'rotation(0deg)';
blueDot.style.display = 'none';
blueDot.setAttribute("aria-label", "Current location marker");

const markerOptions = ref({position: { lat:55.872446, lng:-4.289041 }, content: blueDot });

// call moveCurrentLocation each time geoLocation updates
const watchId = navigator.geolocation.watchPosition(
  moveCurrentLocation,
  function() {},
  {timeout: 1000, enableHighAccuracy: true});

onUnmounted(() => {
  // stops watching geolocation and frees up memory
  navigator.geolocation.clearWatch(watchId);
});

const emit = defineEmits(['newLocation'])

function moveCurrentLocation(position) {
  markerOptions.value =  { position: { lat:position.coords.latitude, lng:position.coords.longitude}, content: blueDot};
  //Emit newLocation event and pass new value
  emit('newLocation', markerOptions.value.position)
  blueDot.style.transform = 'rotate(' + position.coords.heading + 'deg)';
  blueDot.style.display = 'block';
  }
</script>
